import React from 'react';
import { Slider as MaterialSlider, withStyles } from '@material-ui/core';
import { getColor } from 'common/constants/_colors';

export default function Slider(props) {
  const { min, max } = props;
  const { value, onChange } = props;

  const handleChange = (e, newValue) => {
    onChange(newValue);
  };

  const CustomSlider = withStyles({
    root: {
      color: getColor('chambray'),
      height: 8
    },
    markLabel: {
      fontSize: 12
    },
    thumb: {},
    valueLabel: {
      '& *': {
        transform: 'translate(0, 30px)',
        background: 'transparent',
        color: 'mediumblue',
        fontSize: 16,
        fontWeight: 900
      }
    }
  })(MaterialSlider);

  return (
    <CustomSlider
      value={value}
      onChange={handleChange}
      valueLabelDisplay='on'
      min={min}
      max={max}
      step={1}
      marks={[
        { value: min, label: min === value ? '' : min },
        { value: max, label: max === value ? '' : max }
      ]}
      style={{ width: '60%' }}
    />
  );
}
